import { Controller, useFormContext } from "react-hook-form";

import { RadioButtons } from "@smart/itops-sb-design-system-dom";

export const ButtonCornerShape = ({ disabled }: { disabled?: boolean }) => {
  const { control } = useFormContext();

  return (
    <div className="flex flex-col gap-small">
      <div className="text-paragraph font-semibold">Button Corner Shape</div>

      <Controller
        control={control}
        name="buttonRadius"
        render={({ field }) => (
          <RadioButtons
            options={[
              { label: "Square", value: "square" },
              { label: "Slightly Rounded", value: "slightlyRounded" },
              {
                label: "Moderately Rounded (default)",
                value: "moderatelyRounded",
              },
              { label: "Fully Rounded", value: "fullyRounded" },
            ]}
            value={field.value}
            onChange={(value) => field.onChange(value)}
            disabled={disabled}
            className="text-ui"
          />
        )}
      />
    </div>
  );
};
